import { Flex, Spacer, Text } from '@zillow/constellation';
import ResponsiveHeading from 'app/shared/StyledComponents/ResponsiveText';
import styled from 'styled-components';

export const Stripe = styled(Flex)`
    background-color: #f9f9fb;
`;

export const MarketName = styled(Text)`
    width: 45%;
    text-align: center;
    padding-top: 19px;
`;

export const Versus = styled(Text)`
    width: 10%;
    text-align: center;
    padding-top: 19px;
`;

export const AutocompleteContainer = styled(Spacer)`
    width: 45%;
`;

export const RentPrice = styled(ResponsiveHeading)`
    width: 50%;
    text-align: center;
    border-right: 1px solid #d1d1d5;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 160px;
`;

export const OtherRentPrice = styled(ResponsiveHeading)`
    width: 50%;
    text-align: center;
`;
